/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Contact_Reason_Buy_TermInputs */

const en_marketing_contact_reason_buy_term = /** @type {(inputs: Marketing_Contact_Reason_Buy_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buying Onyx`)
};

const es_marketing_contact_reason_buy_term = /** @type {(inputs: Marketing_Contact_Reason_Buy_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprar Onyx`)
};

const fr_marketing_contact_reason_buy_term = /** @type {(inputs: Marketing_Contact_Reason_Buy_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acheter Onyx`)
};

/**
* | output |
* | --- |
* | "Buying Onyx" |
*
* @param {Marketing_Contact_Reason_Buy_TermInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_contact_reason_buy_term = /** @type {((inputs?: Marketing_Contact_Reason_Buy_TermInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Contact_Reason_Buy_TermInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_contact_reason_buy_term(inputs)
	if (locale === "es") return es_marketing_contact_reason_buy_term(inputs)
	return fr_marketing_contact_reason_buy_term(inputs)
});